import React from 'react'
import { Button, Typography } from '@material-ui/core'
import { Formik, Form, connect } from 'formik'
import FormField from 'components/FormField'
import * as Yup from "yup"
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { AccordionActions } from "@material-ui/core";
import API from '../../../../../../util/Api'
import useStyles from './style'

const FormConfig = connect((props) => {
    console.log('RFIDForm-props', props)
    const classes = useStyles();
    return (
        <Form>
            <Typography varient={"h5"} component={"h5"}>
                RFID
            </Typography>
            <div className={"row"}>
                {props.rfidConfig.map((field, index) => {
                    return (
                        <div
                            className={`col-md-${field.size} col-12`}
                            key={`rowField-${field.key}`}
                        >
                            <FormField
                                field={{
                                    ...field,
                                    ...{ name: `rfid.${field.key}` },
                                }}
                            />
                        </div>
                    );
                })}
            </div>
            <Typography varient={"h5"} component={"h5"} className="mt-4">
                Barrier
            </Typography>
            <div className={"row"}>
                {props.barrierConfig.map((field, index) => {
                    return (
                        <div
                            className={`col-md-${field.size} col-12`}
                            key={`rowField-${field.key}`}
                        >
                            <FormField
                                field={{
                                    ...field,
                                    ...{ name: `barriers.${field.key}` },
                                }}
                            />
                        </div>
                    );
                })}
            </div>

            <div className={`mt-4 ${classes.panelAction}`}>
                <AccordionActions>
                    <Button size="small" type="reset">Cancel</Button>
                    <Button size="small" color="primary" type="submit">Save</Button>
                </AccordionActions>
            </div>
        </Form>
    )
})

const RFIDConfig = (props) => {
    const classes = useStyles();
    const validationSchema = () => {
        return Yup.lazy(values => {
            console.log('LedConfigSchema', values)
            return Yup.object().shape({
                rfid: Yup.object().shape({
                    read_interval: Yup.string()
                        .required("Requried"),
                    baudrate: Yup.string()
                        .required("Requried"),
                    reader_mode: Yup.string()
                        .required("Requried"),
                    model: Yup.string()
                    .required("Required"),
                })
            });
        });
    }

    const saveAccessory = (e) => {
        console.log("saveAccessory", e)
        API.post('assignLed', JSON.stringify(e)).then(response => {
            // props.setMessage(response.data.msg)
            props.updateAssignedRFID(response.data.data.rfid)
            props.updateAssignedBarrier(response.data.data.barriers)
            props.setSnackBar({ open: true, msg: response.data.msg, type: 'success' });
        }).catch(err => {
            // props.setMessage('Failed to save')
            console.log(err)
            props.setSnackBar({ open: true, msg: err?.response?.data?.msg ? err.response.data.msg : "Something went wrong", type: 'error' });
        })
    }

    return (
        <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                classes={{ expanded: classes.expanded }}
            >
                <Typography className={classes.panelHeading}>
                    RFID & Barrier Config
                </Typography>
                <Typography className={classes.panelSubheading}></Typography>
            </AccordionSummary>
            <AccordionDetails classes={{ root: classes.panelRoot }}>
                <Formik
                    onSubmit={saveAccessory}
                    initialValues={{
                        "staff_id": props.assignedLed.staff_id,
                        "locationId": props.assignedLed.locationId,
                        "staffName": props.assignedLed.staffName,
                        "barriers": props.assignedLed.barriers,
                        "rfid": props.assignedLed.rfid,
                    }}
                    validationSchema={validationSchema}
                    resetInitalValue={true}
                >
                    <FormConfig
                        onClose={props.onClose}
                        rfidConfig={props.rfidConfig}
                        barrierConfig={props.barrierConfig}
                    />
                </Formik>
            </AccordionDetails>
        </Accordion>
    )
}
export default RFIDConfig;